import { render, staticRenderFns } from "./cl-eval-avg.vue?vue&type=template&id=8a4d6970&scoped=true"
import script from "./cl-eval-avg.vue?vue&type=script&lang=js"
export * from "./cl-eval-avg.vue?vue&type=script&lang=js"
import style0 from "./cl-eval-avg.vue?vue&type=style&index=0&id=8a4d6970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4d6970",
  null
  
)

export default component.exports